import React, {useEffect, useState} from "react";
import {
    Elements,
} from "@stripe/react-stripe-js";
import {loadStripe} from "@stripe/stripe-js";
import ValetPaymentStripe from "./ValetPaymentStripe";
import {useTranslation} from "react-i18next";

export default function ValetPaymentStripeWrapper({
                                                      searchParams
                                                  }) {
    const getStripePK = () => {
        if (process.env.REACT_APP_STRIPE_TEST_MODE == "true") {
            return process.env.REACT_APP_STRIPE_PK_TEST;
        } else {
            return process.env.REACT_APP_STRIPE_PK;
        }
    };

    const [stripePromise, setStripePromise] = useState(() => loadStripe(getStripePK()))
    const {i18n} = useTranslation('common')

    const elementsOptions = {
        mode: 'payment',
        currency: 'chf',
        amount: 100,  // Sera écrasé par le serveur
        locale: i18n.language,
        appearance: {
            theme: 'night',
            variables: {
                // https://docs.stripe.com/elements/appearance-api?platform=web#commonly-used-variables
            }
        },
    };

    return (
        <Elements stripe={stripePromise} options={elementsOptions}>
            <ValetPaymentStripe searchParams={searchParams}/>
        </Elements>)
}